import React, { useEffect, useState } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { fetchItems } from './api';
import ItemList from './Components/ItemList';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NewsLetter from './Components/NewsLetter';

const About: React.FC = () => {

    const settings_home = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: false,
        draggable: false,
        swipe: false
    };

    const useIsMobile = (breakpoint = 768) => {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
          };
      
          window.addEventListener('resize', handleResize);
      
          // Limpia el evento cuando el componente se desmonta
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        }, [breakpoint]);
      
        return isMobile;
      };
    
      const isMobile = useIsMobile();

  return (
    <>

      <div className="page-wrapper">
        <Header />
        <section className="main-slider clearfix home">
        <Slider {...settings_home}>
          <div className="item swiper-slide">
            <div className="image-layer slider1Nosotros" >

            </div>

            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12">
                  <div className="main-slider__content">
                    <h3 className="main-slider__title text-center">                      
                      <span style={{ fontWeight: '600' }}>Más de 4 años de experiencia en la externalización de servicios generales
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>

        <section className="work-detailsNosotros" style={{marginBottom: '0px', paddingTop: '60px', paddingBottom: '40px'}}>
            <div className={isMobile ? 'section-titleMobileVA' : 'section-titleDesktopVA'}>
              <h2 className={isMobile ? 'section-title__titleMobile' : 'section-title__titleDesktop'} style={{marginTop: '-40px'}}>VyL ASOCIADOS</h2>
            </div>
        </section>

        <section className="work-details2">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                       
                    </div>
                </div>
                <div className="work-detailsContacto__content">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <div className="work-details__content-left">
                                <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE text-center'}>Calidad y experiencia</h3>
                                <p className="work-details__text-2">Somos una empresa especializada en la externalización de servicios
                                generales. Nuestro compromiso con la calidad en el trabajo y nuestros
                                trabajadores nos convierte en el mejor aliado empresarial.</p>
                            </div>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <div className="work-details__content-left">
                                <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE text-center'}>Misión</h3>
                                <p className="work-details__text-2">Brindar servicios de ingeniería, construcción, mantenimiento y operación de
                                infraestructura, pública y privada, mediante elevados estándares de calidad
                                y preservación del medioambiente, contribuyendo al desarrollo sostenible.</p>
                            </div>
                        </div>
                    </div>
                     <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <div className="work-details__content-left">
                                <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE text-center'}>Visión</h3>
                                <p className="work-details__text-2">Ser reconocidos como una empresa líder en el mercado nacional e
                                internacional, con excelencia en nuestro modelo de gestión y procesos de
                                innovación, que mejore la calidad de vida a nuestros trabajadores y genere
                                bienestar a la sociedad.</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>

        {/* Sección de Estadísticas */}
        <section style={{
            padding: '80px 0',
            backgroundColor: '#f8f9fa'
        }}>
            <div className="container" style={{
            maxWidth: '1400px'
        }}>
                <div  style={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '20px'
                }}>
                    {/* Estadística 1: +4 años de experiencia */}
                    <div className={isMobile ? 'containerMobile' : 'containerDesktop'}>
                        <div style={{
                            fontSize: '60px',
                            color: '#1e4a72'
                        }}>
                            <img src="/assets/images/backgrounds/Ícono-Nosotros-10-años-de-experiencia.png"
                            width={150}></img>
                        </div>
                        <div>
                            <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE'} style={{
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '0',
                                fontFamily: 'Axiforma-Regular, sans-serif',
                                color: '#1e4a72',
                                lineHeight: '1.2'
                            }}>
                                +4 años de experiencia en<br />
                                la externalización de<br />
                                servicios generales
                            </h3>
                        </div>
                    </div>

                    {/* Estadística 2: Técnicos capacitados */}
                    <div className={isMobile ? 'containerMobile' : 'containerDesktop'}>
                        <div style={{
                            fontSize: '60px',
                            color: '#1e4a72'
                        }}>
                             <img src="/assets/images/backgrounds/Ícono-Técnicos-Capacitados.png" width={150}></img>
                        </div>
                        <div>
                            <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE'} style={{
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '0',
                                fontFamily: 'Axiforma-Regular, sans-serif',
                                color: '#1e4a72',
                                lineHeight: '1.2'
                            }}>
                                Profesionales capacitados<br />
                                y certificados
                            </h3>
                        </div>
                    </div>

                    {/* Estadística 3: +100 proyectos ejecutados */}
                    <div className={isMobile ? 'containerMobile' : 'containerDesktop'}>
                        <div style={{
                            fontSize: '60px',
                            color: '#1e4a72'
                        }}>
                             <img src="/assets/images/backgrounds/Ícono-Proyectos-Ejecutados.png" width={150}></img>
                        </div>
                        <div>
                            <h3 className={isMobile ? 'section-title__title2MobileCE' : 'section-title__title2DesktopCE'} style={{
                                fontSize: '24px',
                                fontWeight: '700',
                                margin: '-30px',
                                fontFamily: 'Axiforma-Regular, sans-serif',
                                color: '#1e4a72',
                                lineHeight: '1.2'
                            }}>
                                +60 proyectos<br />
                                ejecutados
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>

                                     
        <NewsLetter />
      <Footer/>
      </div>
    </>
  );
}

export default About;
